import { render, staticRenderFns } from "./topupwd.vue?vue&type=template&id=c472e6de"
import script from "./topupwd.vue?vue&type=script&lang=js"
export * from "./topupwd.vue?vue&type=script&lang=js"
import style0 from "./topupwd.vue?vue&type=style&index=0&id=c472e6de&prod&lang=scss&scooped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports